define( [
	"../core"
], function( jQuery ) {

"use strict";

jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/core/readyException.js
// module id = 957
// module chunks = 243